import { HTTP_REST_URLS } from "../config/urls"

export const useCategory = (slug) => new Promise((resolve, reject) => {

    const url = HTTP_REST_URLS.CATEGORY_DATA + slug;

    fetch(url)
        .then((res) => (res.json()))
        .then(async(response) => {

            console.log(response)
         
            if(!response.error)
            {
                if(Array.isArray(response?.categories))
                {
                    if(response?.categories?.length > 0)
                    {
                        let obj = {}

                        obj = {...response?.categories[0]}
                        obj['jsonPath'] = response?.path
                        resolve(obj)
                    }
                    else
                    {
                        resolve(false)
                    }
                }
                else
                {
                    resolve(false)
                }
            }
            else
            {
                resolve(false)
            }

        })

})